import React, {FC} from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid, LinearProgress,
    Typography
} from "@material-ui/core";
import {formatDate} from "../../../date.utils";
import {FeOrder} from "../../orders/redux/types";
import {TimePicker} from "@material-ui/pickers";
import {InfoOutlined} from "@material-ui/icons";
import {useUpdateOrder} from "../../orders/redux/orders.hook";

interface FinalizeWorkerOrderDialogProps {
    dialogOpen: boolean;
    toggleDialog: () => void;
    order: FeOrder
}

export const FinalizeWorkerOrderDialog: FC<FinalizeWorkerOrderDialogProps> = ({dialogOpen, toggleDialog, order}) => {
    const [from, setFrom] = React.useState(order.estimatedFrom);
    const [to, setTo] = React.useState(order.estimatedTo);
    const [isLoading, setIsLoading] = React.useState(false);

    const {updateOrder} = useUpdateOrder();

    const handleFinalizeOrder = () => {
        setIsLoading(true);
        updateOrder(order.id, {from, to})
            .then(() => {
                toggleDialog();
                setIsLoading(false);
            })
            .catch(() => {
            });
    }

    return (
        <Dialog open={dialogOpen}>
            <DialogTitle>IST Arbeitszeit</DialogTitle>
            <DialogContent>
                <Typography variant="h6" color="secondary" style={{marginBottom: 8}}>
                    {formatDate(order.estimatedFrom, "EEEE, dd.MM.yyyy")}
                </Typography>
                <DialogContentText>
                    Bitte trage hier deine tatsächlich gearbeitete Zeit ein
                </DialogContentText>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TimePicker
                            cancelLabel={"Zurück"}
                            minutesStep={15}
                            fullWidth
                            ampm={false}
                            label="Start"
                            value={from}
                            onChange={(date) => date && setFrom(date.getTime())}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TimePicker
                            cancelLabel={"Zurück"}
                            minutesStep={15}
                            fullWidth
                            ampm={false}
                            label="Ende"
                            value={to}
                            onChange={(date) => date && setTo(date.getTime())}
                        />
                    </Grid>
                </Grid>
                <div style={{display: "flex", marginTop: 24}}>
                    <InfoOutlined color="primary"/>
                    <Typography variant="body2" style={{marginLeft: 8}} color="textSecondary">
                        Die hier eingetragene Zeit wird dir gutgeschrieben und dem Kunden in Rechnung gestellt. Eventuelle Pausen ziehst du bitte schon von der Gesamtzeit ab.
                    </Typography>
                </div>
            </DialogContent>
            {isLoading
                ? <LinearProgress/>
                : <DialogActions>
                    <Button onClick={toggleDialog}>
                        Abbrechen
                    </Button>
                    <Button
                        color="primary"
                        onClick={handleFinalizeOrder}
                    >
                        Speichern
                    </Button>
                </DialogActions>
            }
        </Dialog>
    )
}
